import { useMutation, useQuery } from "react-query"
import { User } from "../api/user"
import { hydraTransform } from "../shared/utils/hydraTransformer"
import { useMemo } from "react"
import { get, isEmpty, uniqBy } from "lodash"
import { CreateParentChildDto } from "../dto/CreateParentChildDto"

type ThirdPartyUsersProps = {
    enableQuery: boolean,
    userId?: string,
    childOptions?: string,
    parentOptions?: string
}

export const useThirdPartyUsers = ({ enableQuery, userId, childOptions, parentOptions }: ThirdPartyUsersProps) => {

    const thirdPartyUsersQuery = useQuery(
        ['users_parents', parentOptions],
        () => User.getThirdPartyUsers(userId, parentOptions),
        {
            enabled: enableQuery,
            keepPreviousData: true
        }
    )

    const thirdPartyChildUsersQuery = useQuery(
        ['users_childs', childOptions],
        () => User.getThirdPartyUsersChilds(userId, childOptions),
        {
            enabled: enableQuery,
            keepPreviousData: true

        }
    )

    const deleteParentChildMutation = useMutation((id: number) => User.deleteParentChild(id))
    const saveParentChildMutation = useMutation((data: CreateParentChildDto) => User.saveParentChild(data))



    const countParents = get(thirdPartyUsersQuery.data?.data, 'hydra:totalItems', 0)
    const countChildren = get(thirdPartyChildUsersQuery.data?.data, 'hydra:totalItems', 0)

    return {
        isLoadingParents: thirdPartyUsersQuery.isLoading || thirdPartyUsersQuery.isFetching,
        isLoadingChilds: thirdPartyChildUsersQuery.isLoading || thirdPartyChildUsersQuery.isFetching,
        parents: hydraTransform(thirdPartyUsersQuery.data?.data ?? []),
        childs: hydraTransform(thirdPartyChildUsersQuery.data?.data ?? []),
        deleteParentChildMutation,
        saveParentChildMutation,
        countParents,
        countChildren,
        refetchParents:thirdPartyUsersQuery.refetch,
        refetchChilds:thirdPartyChildUsersQuery.refetch,
    }
}